<template>
    <input ref="input" class="saved-input" v-on:change="handleInput()" placeholder=""/>
</template>
<style scoped>
.saved-input{
    font-size: 36px;
    border:0;
    background: url(/pages/img/svgInputBackground.svg), #ffffff;
    background-repeat: repeat-x;
    background-size: auto;
    background-clip: content-box, padding-box;
    background-position: 10% 93%;
    text-align:center;
    outline: 1px solid #a6a6a6;
    padding-bottom: 10px;
    padding-top: 10px;
    padding-right: 10px;
    padding-left: 10px;
}
::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: grey;
  opacity: 1; /* Firefox */
}

:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: grey;
}

::-ms-input-placeholder { /* Microsoft Edge */
  color: grey;
}
</style>
<script>
    export default {
        props: ['type', 'page', 'number'],
        computed: {
            dbId(){
                return `${this.type}-${this.page}-${this.number}`
            },          
        },
        methods: {
            handleInput(){
                this.$db.inputs.put({
                    id: this.dbId,
                    text: this.$refs.input.value
                }).catch(function(error){
                    console.log("error uploading file" + error);
                });
            }
        },
        async created() {
            var value = await this.$db.inputs.get({
                id: this.dbId,
            }).catch(function(error){
                console.log("error uploading file" + error);
            });
            if (value === undefined) return;
            console.log(value);
            this.$refs.input.value = value.text;     
        },
    }
</script>
